<nav class="left_menu_sec">
    <div class="operation_sec layout-config-active">
        <ul class="">
            <li class="operations_data_sec">
                <a class="operations_data" routerLink="../user-module/unit-mine" routerLinkActive="active-link">
                    <div class="operation_icon">
                        <img class="left_menu_icon" src="assets/images/Menu_Icons/dashboard_icon.svg" alt="" title="">
                    </div>
                    <span class="text-color">Overview</span>
                </a>
            </li>
            <li class="operations_data_sec drop-menu" *ngIf="LoadMenuByRole(3)">
                <div class="btn-group dropend">
                    <a routerLink="../user-module/planning" routerLinkActive="active-link" class="operations_data"
                        (click)="showSubmenuFun('Planner New')">
                        <div class="operation_icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <img class="left_menu_icon" src="assets/images/Menu_Icons/calendar_icon.svg" alt=""
                                title="">
                        </div>
                        <span class="text-color"> Planning</span>
                    </a>
                    <ul class="operations_data_view planning_hover dropdown-menu">
                        <li class="">
                            <a class="dropdown-item" routerLink="./planning/annual-plan">Annual/Monthly</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./planning/weekly-plan">Weekly</a>
                        </li>                       
                    </ul>
                </div>
            </li>
            <li class="operations_data_sec drop-menu" *ngIf="LoadMenuByRole(6)">
                <div class="btn-group dropend">
                    <a routerLink="../user-module/drill-blast" routerLinkActive="active-link" class="operations_data">
                        <div class="operation_icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <img class="left_menu_icon" src="assets/images/Menu_Icons/drill_and_blast_icon.svg" alt=""
                                title="">
                        </div>
                        <span class="text-color"> Drill & blast</span>
                    </a>
                    <ul class="operations_data_view dril_blast_hover dropdown-menu">
                        <li class="">
                            <a class="dropdown-item" routerLink="./drill-blast/blast-survey">Blast Survey</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./drill-blast/sampling-survey">Sampling Survey</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./drill-blast/blast-performance">Blast Performance</a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="operations_data_sec drop-menu" *ngIf="LoadMenuByRole(7)">
                <div class="btn-group dropend">
                    <a routerLink="../user-module/grade-control" routerLinkActive="active-link" class="operations_data">
                        <div class="operation_icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <img class="left_menu_icon" src="assets/images/Menu_Icons/grade_control_%20icon.svg" alt=""
                                title="">
                        </div>
                        <span class="text-color"> Grade Control</span>
                    </a>
                    <ul class="operations_data_view gradeControl_hover dropdown-menu">
                        <li class="">
                            <a class="dropdown-item" routerLink="./grade-control/lab-input">Lab Results</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./grade-control/pile-planning">Pile Planning</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./grade-control/slice-plan-reconciliation">Slice
                                Plan Reconciliation</a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="operations_data_sec drop-menu" *ngIf="LoadMenuByRole(4)">
                <div class="btn-group dropend">
                    <a routerLink="../user-module/operations-control" routerLinkActive="active-link"
                        class="operations_data">
                        <div class="operation_icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <img class="left_menu_icon" src="assets/images/Menu_Icons/operation_icon.svg" alt=""
                                title="">
                        </div>
                        <span class="text-color"> Operations</span>
                    </a>
                    <ul class="operations_data_view operation_hover dropdown-menu">
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/inventory-tab">Material
                                Inventory</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/crusher-status">Crusher Status</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/oc-cba-pile-crusher-tab">Pile
                                Status</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/excavator">Loading Equipment</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/dumper">Transport Equipment</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink='./operations-control/operator'>Operator Status</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/Resource-Allocation">Resource
                                Allocation</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/geospatial-display">Equipment
                                Tracking</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/route-replay">Route Replay</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./operations-control/shift-report">Shift Report</a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="operations_data_sec drop-menu" *ngIf="LoadMenuByRole(5)">
                <div class="btn-group dropend">
                    <a routerLink="../user-module/um-maintenance" routerLinkActive="active-link"
                        class="operations_data">
                        <div class="operation_icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <img class="left_menu_icon" src="assets/images/Menu_Icons/maintenance_icon.svg" alt=""
                                title="">
                        </div>
                        <span class="text-color"> Maintenance</span>
                    </a>
                    <ul class="operations_data_view maintenance_hover dropdown-menu">
                        <li class="">
                            <a class="dropdown-item" routerLink="./um-maintenance/equipment-maintenance">Equipment
                                Maintenance</a>
                        </li>
                        <li class="">
                            <a class="dropdown-item" routerLink="./um-maintenance/crusher-maintenance">Crusher
                                Maintenance</a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="operations_data_sec" *ngIf="LoadMenuByRole(2)">
                <a routerLink="../user-module/mine-insights" routerLinkActive="active-link" class="operations_data">
                    <div class="operation_icon">
                        <img class="left_menu_icon" src="assets\images\Menu_Icons/insight_icon.svg" alt="" title="">
                    </div>
                    <span class="text-color"> Mine Insights </span>
                </a>
            </li>
            <li class="operations_data_sec" *ngIf="LoadMenuByRole(9)">
                <a routerLink="../user-module/sap" routerLinkActive="active-link" class="operations_data">
                    <div class="operation_icon">
                        <img class="sap_left_menu_icon" src="assets/images/Menu_Icons/SapM-icon.svg" alt="" title="">
                    </div>
                    <span class="text-color">SAP</span>
                </a>
            </li>
            <li class="operations_data_sec" *ngIf="LoadMenuByRole(12)">
                <a class="operations_data" routerLink="../user-module/diagnostics" routerLinkActive="active-link">
                    <div class="operation_icon">
                        <img class="left_menu_icon" src="assets/images/Menu_Icons/Diagnostics_icon.svg" alt="" title="">
                    </div>
                    <span class="text-color">Diagnostics</span>
                </a>
            </li>
        </ul>
    </div>
</nav>